import React from 'react'
import { useRef } from 'react';
import useViewPort from '../../hooks/useViewPort';
import { useSpring, animated } from 'react-spring'

function ScrollComponents({children, springConfig, className}) {
  const ref = useRef()
  const inViewport = useViewPort(ref, '0px')

  const styles = useSpring({
    reverse: !inViewport,
    ...springConfig,
  })

  if (inViewport) {
    console.log('in viewport:', ref.current);
  }
  
  return (
    <animated.div ref={ref} style={styles} className={className}>
      {children}
    </animated.div>
  )
}

export default ScrollComponents
